<template>
  <div>
    <p>
      {{ formatDuration }}
    </p>
  </div>
</template>
<script>
export default {
  name: 'TableCellDuration',
  props: {
    payload: Object
  },
  computed: {
    formatDuration () {
      return `${this.$moment(new Date())
        .diff(new Date(this.payload.updated_at), 'minutes')
        .toString()} minutes`
    }
  }
}
</script>
